import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise"; // Import Ag-Grid Enterprise features
import "ag-grid-enterprise/styles/ag-grid.css";
import "ag-grid-enterprise/styles/ag-theme-alpine.css";
import "../AgTable.scss";
// import "../AgTheme.css";

import { Button, Empty, message, Tag } from "antd";
import {
  DownloadOutlined,
  CheckCircleFilled,
  CloseCircleFilled,
} from "@ant-design/icons";
import { handleAgCellDataFormat, handleCellRenderer } from "../AgServerUtility";
import React, {
  forwardRef,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import PDFViewerTool from "../HelperTools/PDFViewerTool";
import { useRecoilState } from "recoil";
import { userInfo } from "app/config/States/users";
import Loader from "app/shared/Loader";
import PDFViewerToolV2 from "../HelperTools/PDFViewerTool/pdfViewerV2";
import { apiGet, apiPost, apiPut } from "app/services/apiServices";
import {
  API_ENDPOINT_AG_TABLE_LIST_ALL_VIEW,
  API_ENDPOINT_AG_TABLE_LOAD_VIEW,
  API_ENDPOINT_AG_TABLE_SAVE_VIEW,
  API_ENDPOINT_AG_TABLE_UPDATE_VIEW,
} from "../AgTable.constants";
import { agTableRowSize, tableSchema,activeTableNameState } from "app/config/States/agtable";
import MasterDetail from "./MasterDetail";
import Typography from "app/shared/Typography";
import { colorPicker } from "app/utils/color.helper";
import CRMTransfers from "app/shared/CRMTRansfer";
import moment from "moment";
import { tabViewStates, activeTabAtom } from "app/config/States/users";
import { useRecoilValue } from "recoil";
const AgTableServer = forwardRef((props, ref) => {
  const [gridApi, setGridApi] = useState(null);
  const [columnDefs, setColumnDefs] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [userDetails, _] = useRecoilState(userInfo);
  const [isLoading, setLoading] = useState(false);
  const [grandTotalRow, setGrandTotalRow] = useState(null);
  const [messageApi, contextHolder] = message.useMessage();
  const [loadingView, setLoadingView] = useState(false);
  const [initialColumnState, setInitialColumnState] = useState([]);
  const [tableRowSize, setTableRowSize] = useRecoilState(agTableRowSize);
  const [filteredColDefs, setFilteredColDefs] = useState([]);
  const [currentPayload, setCurrentPayload] = useState(null);
  const [enableAPI, setEnableAPI] = useState(false);
  const gridRef = useRef();
  const tableName = useRecoilValue(activeTableNameState);
  const onCellValueChange = (event) => {
  };
  const activeTab = useRecoilValue(activeTabAtom);

  const processColumnDefs = (columnDefs) => {
    return (columnDefs || []).map((obj) => ({
      ...obj, // Spread the original object
      ...(obj.formatType ? handleCellRenderer() : {}), // Add the new key-value pair
    }));
  };

  const getColumnDefsGenerated = (rowArray) => {
    let columnItems = [];
    let loopableData = Object.entries(rowArray[0] || {}) || [];
    let dynamicConfig = {
      number: {
        filter: "agNumberColumnFilter",
        enableValue: true,
      },
      string: {
        enableRowGroup: true,
        filter: "agTextColumnFilter",
      },
    };
    loopableData.forEach((rowItem) => {
      let value = rowItem[1];
      let typeOfData = typeof value;
      // Check if the value is a JSON string (from nested object processing)
      const isJsonString = typeOfData === 'string' && value.trim().startsWith('{') && value.trim().endsWith('}');
      
      columnItems.push({
        headerName: rowItem[0],
        field: rowItem[0],
        ...dynamicConfig[typeOfData === 'number' ? 'number' : 'string'],
        // If it's a JSON string, add a cell renderer to display it nicely
        ...(isJsonString ? {
          cellRenderer: (params) => {
            try {
              const parsed = JSON.parse(params.value);
              return JSON.stringify(parsed, null, 2);
            } catch {
              return params.value;
            }
          }
        } : {})
      });
    });
    setColumnDefs(columnItems);
  };

  // const fetchServerSide = useCallback(async () => {
  //   // Update the grid data
  //   gridApi.setServerSideDatasource({
  //     getRows: function (params) {
  //       setCurrentPayload(params.request);
  //       // Use the fetched data to update the grid
  //       fetch(props.endpoint || "", {
  //         method: "POST",
  //         body: JSON.stringify({
  //           ...params.request,
  //           ...props.serverPayload,
  //           useWorkspace: props.useWorkspace,
  //           userDetails:userDetails,
  //           activeTab:activeTab
            
  //         }),
  //         headers: {
  //           "Content-Type": "application/json; charset=utf-8",
  //           Authorization: "Bearer " + localStorage.getItem("token"),
  //           workspaceId: localStorage.getItem("currentWorkspace"),
  //           // platform: process.env.APP_ENV || "mmt",
  //           platform: "mmt",
  //         },
  //       })
  //         .then((httpResponse) => httpResponse.json())
  //         .then((response) => {
  //           props.onDataSuccess && props.onDataSuccess(response.data.rows);
  //           params.success({
  //             rowData: response.data.rows,
  //             rowCount: response.data.lastRow,
  //             ...(response.data.pivotResultFields &&
  //             response.data.pivotResultFields.length > 0
  //               ? { pivotResultFields: response.data.pivotResultFields }
  //               : {}),
  //           });
  //           props.setData && props.setData(response.data.rows.slice(0, 10));
  //           if (props.generateColumn)
  //             getColumnDefsGenerated(response.data.rows);

  //           console.log(
  //             "response.data.grandTotalRow",
  //             props.defaultView,
  //             response.data.grandTotalRow
  //           );
  //           setGrandTotalRow(
  //             JSON.parse(JSON.stringify(response.data.grandTotalRow))
  //           );

  //           setRowData(response.data.rows);
  //           // handleColumnRowGroupChanged(params);
  //         })
  //         .catch((error) => {
  //           console.error(error);
  //           params.fail();
  //         });
  //       setLoading(false);
  //     },
  //   });
  // }, [
  //   gridApi,
  //   props.useWorkspace,
  //   userDetails.currentWorkspace,
  //   props.serverPayload,
  // ]);




  const fetchServerSide = useCallback(async () => {
  gridApi.setServerSideDatasource({
    getRows: function (params) {
      setCurrentPayload(params.request);
      

      const apiPayload = {
        ...params.request,
        ...props.serverPayload,
        useWorkspace: props.useWorkspace,
        userDetails: userDetails,
        activeTab: activeTab,
        tableName: props.tableName || tableName
      };
      
      fetch(props.endpoint || "", {
        method: "POST",
        body: JSON.stringify(apiPayload),
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          Authorization: "Bearer " + localStorage.getItem("token"),
          workspaceId: localStorage.getItem("currentWorkspace"),
           // platform: process.env.APP_ENV || "mmt",
          platform: "app",
        },
      })
        .then((httpResponse) => httpResponse.json())
        .then((response) => {
          // Recursive function to process nested objects
          const processValue = (value) => {
            // Convert numeric strings to numbers
            if (typeof value === 'string' && !isNaN(value) && value.trim() !== '') {
              return Number(value);
            }
            // Convert nested objects to JSON strings to prevent React rendering errors
            if (value !== null && typeof value === 'object') {
              if (value instanceof Date) {
                return value;
              }
              if (Array.isArray(value)) {
                // Process array items
                return value.map(item => processValue(item));
              }
              // Convert object to JSON string
              return JSON.stringify(value);
            }
            return value;
          };

          // Convert numeric strings to numbers and handle nested objects
          const processedRows = response.data.rows.map(row => {
            return Object.fromEntries(
              Object.entries(row).map(([key, value]) => {
                return [key, processValue(value)];
              })
            );
          });

          props.onDataSuccess && props.onDataSuccess(processedRows);

          params.success({
            rowData: processedRows,
            rowCount: response.data.lastRow,
            ...(response.data.pivotResultFields &&
            response.data.pivotResultFields.length > 0
              ? { pivotResultFields: response.data.pivotResultFields }
              : {}),
          });

          props.setData && props.setData(processedRows.slice(0, 10));

          if (props.generateColumn) getColumnDefsGenerated(processedRows);

          console.log(
            "response.data.grandTotalRow",
            props.defaultView,
            response.data.grandTotalRow
          );
          setGrandTotalRow(
            JSON.parse(JSON.stringify(response.data.grandTotalRow))
          );

          setRowData(processedRows);
        })
        .catch((error) => {
          params.fail();
        });

      setLoading(false);
    },
  });
}, [
  gridApi,
  props.useWorkspace,
  userDetails.currentWorkspace,
  props.serverPayload,
]);


  useEffect(() => {
    if (gridApi && enableAPI) {
      fetchServerSide();
    }
  }, [
    fetchServerSide,
    gridApi,
    userDetails.currentWorkspace,
    enableAPI,
    props.serverPayload,
  ]);



  const onGridReady = useCallback(
    async (params) => {
      const columnApi = params.columnApi;
      setInitialColumnState(columnApi.getColumnState());
      setGridApi(params.api);
      // params.api.setServerSideDatasource(datasource);
      let processDefs = processColumnDefs(props.columnDefs);

      setColumnDefs([...processDefs]);

      if (props.defaultView) {
        loadGridView(props.defaultView, props.moduleId);
      } else {
        setEnableAPI(true);
      }
    },
    [props.columnDefs, props.defaultView]
  );

  // // Keep grid column definitions in sync when parent updates them after mount
  // useEffect(() => {
  //   const processDefs = processColumnDefs(props.columnDefs || []);
  //   setColumnDefs([...processDefs]);
  // }, [props.columnDefs]);
  useEffect(() => {
    if (!props.columnDefs || props.columnDefs.length === 0) return;
    setColumnDefs((prevDefs) => {
      const prevFields = prevDefs.map((c) => c.field).join(",");
      const nextFields = props.columnDefs.map((c) => c.field).join(",");
      // Only refresh if actual column fields changed
      if (prevFields === nextFields) {
        return prevDefs;
      }
      const processDefs = processColumnDefs(props.columnDefs);
      return [...processDefs];
    });
  }, [props.columnDefs]);


  // const exportDataToExcel = useCallback(() => {
  //   gridRef.current.api.exportDataAsExcel({
  //     allColumns: true,
  //     fileName: "export.xlsx",
  //     sheetName: "Data",
  //     columnWidth: (params) => {
  //       return params.column.getColDef().headerName.length * 10;
  //     },
  //     rowHeight: 25,
  //   });
  // }, [gridRef]);

  const getGridState = () => {
    const gridApi = gridRef.current?.api;
    const columnApi = gridRef.current.columnApi;
    if (!gridApi) return "Grid api is not initialized";


    return {
      columnState: columnApi.getColumnState(),
      sortState: columnApi
        .getAllGridColumns()
        .map((col) => ({
          colId: col.getColId(),
          sort: col.getSort(),
        }))
        .filter((col) => col.sort),
      filterState: gridApi.getFilterModel(),
      pivotMode: columnApi.isPivotMode(),
      rowGroupColumns: columnApi.getRowGroupColumns().map((col) => col.colId),
      pivotColumns: columnApi.getPivotColumns().map((col) => col.colId),
    };
  };

  const saveGridView = async (viewName, moduleId) => {
    console.log("Inside save view of ag table server")
    const cleanModuleId = typeof moduleId === 'string'
    ? moduleId.replace(/_\d+$/, '')
    : moduleId;

    const gridState = getGridState();
    const payload = {
      name: viewName,
      gridState: gridState,
      moduleId: cleanModuleId,
      ...props.TableViewPayload,
    };
    const response = await apiPost(API_ENDPOINT_AG_TABLE_SAVE_VIEW, payload);
    if (response.status) {
      messageApi.success({
        type: "success",
        content: "Awesome👍 , your view is created",
      });
    } else {
      messageApi.error({
        type: "error",
        content: "Could not save view, please try again",
      });
    }
  };

  const updateGridView = async (viewId, moduleId) => {
    const gridState = getGridState();
    const payload = {
      viewId: viewId,
      gridState: gridState,
      moduleId: moduleId,
      workspaceId: props.currentWorkspaceId,
      ...props.TableViewPayload,
    };
    const response = await apiPut(
      `${API_ENDPOINT_AG_TABLE_UPDATE_VIEW}${viewId}/update`,
      payload
    );
    if (response.status) {
      messageApi.success({
        type: "success",
        content: "Awesome👍 , your view is updated",
      });
    } else {
      messageApi.error({
        type: "error",
        content: "Could not save view, please try again",
      });
    }
  };
  //need to check----
  const loadGridView = async (viewId, moduleId) => {

    const gridApi = gridRef.current.api;
    const columnApi = gridRef.current.columnApi;

    if (viewId === "DEFAULT") {
      if (columnApi) {
        gridApi.resetColumnState();

        columnApi.applyColumnState({
          state: initialColumnState,
          applyOrder: false,
        });
        setLoadingView(false);

        columnApi.setRowGroupColumns([]); // Set row group columns
        columnApi.setPivotColumns([]); // Set pivot columns
        columnApi.setPivotMode(false); // Set pivot mode
      }

      // Apply sort and filter states
      if (gridApi) {
        gridApi.setFilterModel({}); // Apply filter model

        gridApi.refreshClientSideRowModel(); // Refresh the grid to apply the sorting
      }

      return;
    }
    const workspaceSegment = props.currentWorkspaceId
      ? `${props.currentWorkspaceId}`
      : "";
    const response = await apiGet(
      `${API_ENDPOINT_AG_TABLE_LOAD_VIEW}${moduleId}/${viewId}/${workspaceSegment}`
    );

    if (response.status && response.data) {
      const view = response.data;

      // Apply column state
      if (columnApi && view?.state?.columnState) {
        columnApi.applyColumnState({
          state: view?.state?.columnState,
          applyOrder: true,
        }); // Apply column state
        columnApi.setRowGroupColumns(view.state.rowGroupColumns); // Set row group columns
        columnApi.setPivotColumns(view.state.pivotColumns); // Set pivot columns
        columnApi.setPivotMode(view.state.pivotMode); // Set pivot mode
      }

      // Apply sort and filter states
      if (gridApi && view.state && view.state.filterState) {
        gridApi.setFilterModel(view.state.filterState); // Apply filter model

        // Apply sorting manually
        view.state.sortState.forEach((sort) => {
          gridApi.getColumnState().forEach((column) => {
            if (column.colId === sort.colId) {
              column.sort = sort.sort;
            }
          });
        });
        gridApi.refreshClientSideRowModel(); // Refresh the grid to apply the sorting
      }
    }
    setEnableAPI(true);
  };



  const loadGridView2 = (state) => {
    if (!state) return;
  
    const gridApi = gridRef.current?.api;
    const columnApi = gridRef.current?.columnApi;
  
    if (!gridApi || !columnApi) return;
  
    // Columns
    if (state.columnState?.length > 0) {
      columnApi.applyColumnState({ state: state.columnState, applyOrder: true });
    }
    if (state.columnGroupState?.length > 0) {
      columnApi.setColumnGroupState(state.columnGroupState);
    }
  
    // Pivot & grouping
    if (state.pivotMode !== undefined) columnApi.setPivotMode(state.pivotMode);
    const rowGroupColIds = (state.rowGroupCols || []).map(col => col.colId || col.field);
    columnApi.setRowGroupColumns(rowGroupColIds);
    columnApi.setPivotColumns(state.pivotCols || []);
  
    // Filters (applied only on first restore)
    // if (state.filterModel) gridApi.setFilterModel(state.filterModel);
    if (state.filterModel !== undefined) {
      gridApi.setFilterModel(state.filterModel);
    }
  
    // Sorting
    if (state.sortModel?.length > 0) {
      columnApi.applyColumnState({
        state: state.sortModel.map(sort => ({ colId: sort.colId, sort: sort.sort })),
        defaultState: { sort: null },
      });
    }
  
    // Pagination
    if (state.pagination) {
      gridApi.paginationSetPageSize(state.pagination.pageSize);
      gridApi.paginationGoToPage(state.pagination.currentPage);
    }
  
    // Refresh grid (server-side)
    if (gridApi.refreshServerSideStore) {
      gridApi.refreshServerSideStore({ purge: true });
    } else {
      gridApi.refreshServerSide();
    }
  };

  const handleFirstDataRendered = (params) => {
    if (props.restoreStateOnServer && props.state) {
      loadGridView2(props?.state.serverPayload);
      props?.setRestoreStateOnServer?.setRestoreStateOnServer(false); // now works!
    }
  };
  const getServerSidePayload = () => {
    return currentPayload;
  };

  const applyTestView = (viewConfig) => {
    const columnApi = gridRef.current.columnApi;
    const gridApi = gridRef.current.api;

    if (
      viewConfig.rowGroupCols.length === 0 &&
      viewConfig.sortModel.length === 0 &&
      viewConfig.valueCols.length === 0 &&
      Object.entries(viewConfig.filterModel).length === 0 &&
      !viewConfig.pivotMode
    ) {
      gridApi.resetColumnState();

      columnApi.applyColumnState({
        state: initialColumnState,
        applyOrder: false,
      });
      setLoadingView(false);

      columnApi.setRowGroupColumns([]); // Set row group columns
      columnApi.setPivotColumns([]); // Set pivot columns
      columnApi.setPivotMode(false); // Set pivot mode
    }

    const rowGroupCols = viewConfig.rowGroupCols.map((item) => ({
      colId: item.field || item.id,
      rowGroup: true,
    }));

    columnApi.setPivotColumns(viewConfig.pivotCols.map((item) => item.field));
    columnApi.setValueColumns(viewConfig.valueCols.map((item) => item.field));
    columnApi.applyColumnState({
      state: rowGroupCols,
      applyOrder: true,
    }); // Apply column state

    // Apply filters (if any)

    gridApi.setFilterModel(viewConfig.filterModel); // Apply filter model

    // Apply sorting (if any)

    const currentColumnState = gridApi.getColumnState();
    const sortModelMap = new Map(
      viewConfig.sortModel.map((sort) => [sort.colId, sort.sort])
    );

    const updatedColumnState = currentColumnState.map((column) => {
      if (sortModelMap.has(column.colId)) {
        return { ...column, sort: sortModelMap.get(column.colId) };
      }
      return column;
    });

    // Set the updated column state
    gridApi.applyColumnState({
      state: updatedColumnState,
      applyOrder: true,
    }); // gridApi.refreshServerSideStore({ purge: true });
    // gridApi.refreshServerSideStore({ purge: true });
    // Enable pivot mode (if needed)
    columnApi.setPivotMode(viewConfig.pivotMode);

    // Trigger a refresh of the server-side data
    // gridApi.refreshClientSideRowModel();
  };
  const updateFilteredColumn = () => {
    // setFilteredColDefs(getGridState());
  };

  const getAllColumns = () => {
    return columnDefs;
  };

  React.useImperativeHandle(ref, () => ({
    api: gridRef.current?.api,
    exportDataToExcel,
    getGridState,
    saveGridView,
    loadGridView,
    updateGridView,
    getServerSidePayload,
    applyTestView,
    getAllColumns,
    exportExcelDataRaw,
    exportMultipleSheetAsNewExcel,
    getGridState,
    columnApi: gridRef.current?.columnApi,
    setFilterModel: (model) => {
      gridRef.current?.api?.setFilterModel(model);
    },
    loadGridView2,
  }));

  const statusBar = {
    statusPanels: [
      {
        statusPanel: "agTotalAndFilteredRowCountComponent",
        align: "left",
      },
      {
        statusPanel: "agTotalRowCountComponent",
        align: "center",
      },
      {
        statusPanel: "agFilteredRowCountComponent",
        align: "center",
      },
      {
        statusPanel: "agSelectedRowCountComponent",
        align: "right",
      },
      {
        statusPanel: "agAggregationComponent",
        align: "right",
      },
    ],
  };

  function generateColumnDefsFromPayload(payload) {
    const columnDefs = [];

    // Add row group columns (from rowGroupCols)
    payload.rowGroupCols.forEach((col) => {
      columnDefs.push({
        field: col.field,
        headerName: col.displayName || col.field, // Use displayName if provided, otherwise fallback to field name
        rowGroup: true, // Mark this column as a group column
        hide: true, // Hide the column since it's used for grouping
      });
    });

    // Add value columns (from valueCols) for aggregation
    payload.valueCols.forEach((col) => {
      columnDefs.push({
        field: col.field,
        headerName: col.displayName || col.field, // Use displayName if provided
        aggFunc: col.aggFunc, // Set the aggregation function (e.g., 'sum')
        enableValue: true, // Mark this column for aggregation
      });
    });

    // Handle pivot columns if any (from pivotCols)
    if (payload.pivotCols && payload.pivotCols.length > 0) {
      payload.pivotCols.forEach((col) => {
        columnDefs.push({
          field: col.field,
          headerName: col.displayName || col.field,
          pivot: true, // Mark this column as a pivot column
        });
      });
    }

    return columnDefs;
  }

  const sideBar = useMemo(
    () => ({
      toolPanels: [
        {
          id: "columns",
          labelDefault: "Columns",
          labelKey: "columns",
          iconKey: "columns",
          toolPanel: "agColumnsToolPanel",
        },
        {
          id: "filters",
          labelDefault: "Filters",
          labelKey: "filters",
          iconKey: "filter",
          toolPanel: "agFiltersToolPanel",
        },
        {
          id: "pdfRenderer",
          labelDefault: "PDF View",
          labelKey: "pdfRenderer",
          iconKey: "pdf-file",
          width: 500,
          toolPanel: props.pdfV2 ? PDFViewerToolV2 : PDFViewerTool,
          toolPanelParams: {
            dataKey: props.pdfDataKey,
            pdfData: props.pdfData,
          },
        },
        {
          id: "crmTransfer",
          labelDefault: "CRM Transfer",
          labelKey: "crmTransfer",
          width: 500,
          toolPanel: CRMTransfers,
          toolPanelParams: {
            columnDefs:
              filteredColDefs.length > 0 ? filteredColDefs : props.columnDefs,
            ...props.toolPanelProps,
          },
        },
        // ...(props.showCRM
        //   ? [
        //       {
        //         id: "crmTransfer",
        //         labelDefault: "CRM Transfer",
        //         labelKey: "crmTransfer",
        //         width: 500,
        //         toolPanel: CRMTransfers,
        //         toolPanelParams: {
        //           columnDefs:
        //             filteredColDefs.length > 0
        //               ? filteredColDefs
        //               : props.columnDefs,
        //           ...props.toolPanelProps,
        //         },
        //       },
        //     ]
        //   : []),
      ],
    }),
    [props.pdfData, props.toolPanelProps, filteredColDefs]
  );

  const processColumns = (columns, data) => {
    return columns.reduce((acc, colDef) => {
      if (colDef.children) {
        // Recursively process child columns
        Object.assign(acc, processColumns(colDef.children, data));
      } else {
        const field = colDef.field;
        const headerName = colDef.headerName;

        if (colDef.enableValue) {
          // Ensure that summation occurs correctly by converting to numbers
          acc[headerName] = data.reduce(
            (sum, row) => sum + (parseFloat(row[field]) || 0),
            0
          );
        } else {
          // Count the occurrences if the column has enableValue as false
          acc[headerName] = data.length;
        }
      }
      return acc;
    }, {});
  };
  const getSummaryObject = () => {
    if (gridRef.current && gridRef.current.api) {
      const allDisplayedRowNodes = [];
      gridRef.current.api.forEachNode((node) => {
        if (node.displayed) {
          allDisplayedRowNodes.push(node.data);
        }
      });

      const columnDefs = gridRef.current.api.getColumnDefs();
      const summaryObject = processColumns(columnDefs, allDisplayedRowNodes);
      return summaryObject;
    }
  };

  const exportExcelDataRaw = useCallback((sheetName) => {
    const dataSheet = gridRef.current.api.getSheetDataForExcel({
      sheetName: sheetName,
      processRowGroupCallback: (params) => {
        // This ensures that we strip the "->" from the grouped row labels
        const groupName = params.node.key;
        return groupName?.startsWith("->")
          ? groupName.replace("-> ", "")
          : groupName;
      },
      processCellCallback: (params) => {
        if (typeof params.value === "number") {
          // Return just the number to ensure it stays as a number in Excel
          return params.value;
        }
        const value = params.value;
        if (typeof value === "string" && value?.startsWith("->")) {
          return value.replace("-> ", ""); // Removing "-> " from grouped rows
        }
        return value;
      },
    });
    return dataSheet;
  });

  const exportMultipleSheetAsNewExcel = useCallback(
    (spreadsheets, reportName) => {
      gridRef.current.api.exportMultipleSheetsAsExcel({
        data: spreadsheets,
        fileName: `${reportName}.xlsx`,
      });
    }
  );
  const exportDataToExcel = useCallback(() => {
    const performExport = async () => {
      const spreadsheets = [];

      if (props.exportWithCover) {
        let summaryObject = getSummaryObject();

        const columnDefs = gridRef.current?.api?.getColumnDefs();

        let cellColumnData = [];
        columnDefs.forEach((colDef) => {
          if (colDef.children && colDef.children.length > 0) {
            colDef.children.forEach((childColDef) => {
              cellColumnData.push({
                cells: [
                  {
                    styleId: "headerName",
                    data: {
                      value: childColDef.headerName,
                      type: "String",
                    },
                  },
                  {
                    styleId: "",
                    data: {
                      value: childColDef.enableValue ? "NUMBER" : "STRING",
                      type: "String",
                    },
                  },
                  {
                    styleId: "",
                    data: {
                      value: childColDef.enableValue ? "SUM" : "COUNT",
                      type: "String",
                    },
                  },
                  {
                    styleId: "",
                    data: {
                      value: colDef.rowGroup ? "YES" : "NO",
                      type: "String",
                    },
                  },
                  {
                    styleId: "",
                    data: {
                      value: colDef.aggFunc ? "YES" : "NO",
                      type: "String",
                    },
                  },
                  {
                    styleId: "",
                    data: {
                      value: colDef.aggFunc ? "YES" : "NO",
                      type: "String",
                    },
                  },
                  {
                    styleId: "numberFormat",
                    data: {
                      value: summaryObject[childColDef.headerName],
                      type: "Number",
                    },
                  },
                ],
              });
            });
          } else {
            cellColumnData.push({
              cells: [
                {
                  styleId: "",
                  data: {
                    value: colDef.headerName,
                    type: "String",
                  },
                },
                {
                  styleId: "",
                  data: {
                    value: colDef.enableValue ? "NUMBER" : "STRING",
                    type: "String",
                  },
                },
                {
                  styleId: "",
                  data: {
                    value: colDef.enableValue ? "SUM" : "COUNT",
                    type: "String",
                  },
                },
                {
                  styleId: "",
                  data: {
                    value: colDef.rowGroup ? "YES" : "NO",
                    type: "String",
                  },
                },
                {
                  styleId: "",
                  data: {
                    value: colDef.aggFunc ? "YES" : "NO",
                    type: "String",
                  },
                },
                {
                  styleId: "",
                  data: {
                    value: colDef.aggFunc ? "YES" : "NO",
                    type: "String",
                  },
                },
                {
                  styleId: "numberFormat",
                  data: {
                    value: summaryObject[colDef.headerName],
                    type: "Number",
                  },
                },
              ],
            });
          }
        });
        let FinkraftLogoBase64 =
          "data:image/png;base64,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";
        // First sheet (cover sheet) with custom content only
        const coverSheet = gridRef.current.api.getSheetDataForExcel({
          prependContent: [
            {
              cells: [
                {
                  styleId: "",
                  mergeAcross: 6,
                  data: {
                    type: "String",
                    value: FinkraftLogoBase64, // see imageUtils
                  },
                },
              ],
            },
            {
              cells: [],
            },

            {
              cells: [
                {
                  styleId: "coverHeading",
                  mergeAcross: 6,
                  data: { value: "Policy Bazar Recon Report", type: "String" },
                  rowHeight: 30,
                },
              ],
            },
            {
              cells: [
                {
                  mergeAcross: 6,
                  data: { value: "", type: "String" },
                },
              ],
            },
            {
              cells: [
                {
                  styleId: "coverSubHeader",
                  data: { value: "Created By", type: "String" },
                },
                {
                  styleId: "coverSubHeader",
                  data: { value: userDetails?.email, type: "String" },
                },
                {
                  styleId: "coverSubHeader",
                  mergeAcross: 4,
                  data: { value: "", type: "String" },
                },
              ],
            },
            {
              cells: [
                {
                  styleId: "coverSubHeader",
                  data: { value: "Email/Phone", type: "String" },
                },
                {
                  styleId: "coverSubHeader",
                  data: { value: userDetails?.email, type: "String" },
                },
                {
                  styleId: "coverSubHeader",
                  mergeAcross: 4,
                  data: { value: "", type: "String" },
                },
              ],
            },
            {
              cells: [
                {
                  styleId: "coverSubHeader",
                  data: { value: "Created On", type: "String" },
                },
                {
                  styleId: "coverSubHeader",
                  data: {
                    value: moment().format("DD/MM/YYYY"),
                    type: "String",
                  },
                },
                {
                  styleId: "coverSubHeader",
                  mergeAcross: 4,
                  data: { value: "", type: "String" },
                },
              ],
            },
            {
              cells: [
                {
                  mergeAcross: 6,
                  data: { value: "", type: "String" },
                },
              ],
            },
            {
              cells: [
                {
                  mergeAcross: 6,
                  data: { value: "", type: "String" },
                },
              ],
            },
            {
              cells: [
                {
                  styleId: "header",
                  data: {
                    value: "Column",
                    type: "String",
                  },
                },
                {
                  styleId: "header",
                  data: {
                    value: "Data Type",
                    type: "String",
                  },
                },
                {
                  styleId: "header",
                  data: {
                    value: "Aggregation Type",
                    type: "String",
                  },
                },
                {
                  styleId: "header",
                  data: {
                    value: "Using Grouping",
                    type: "String",
                  },
                },
                {
                  styleId: "header",
                  data: {
                    value: "Using Pivot",
                    type: "String",
                  },
                },
                {
                  styleId: "header",
                  data: {
                    value: "Using Filter",
                    type: "String",
                  },
                },
                {
                  styleId: "header",
                  data: {
                    value: "Aggregation Value",
                    type: "String",
                  },
                },
              ],
            },
            ...cellColumnData,
          ],
          columnWidth: (params) => {
            if (params.index === 0) {
              // Assuming you want to customize the first column
              return 400; // Custom width for the first column in pixels
            }
            return 150; // Default width for other columns
          },

          processHeaderCallback: () => "",
          processRowGroupCallback: () => "",
          processGroupHeaderCallback: () => "",
          processCellCallback: () => "",
          sheetName: "cover",
        });

        spreadsheets.push(coverSheet);
      }
      // Second sheet with actual grid data
      const dataSheet = gridRef.current.api.getSheetDataForExcel({
        sheetName: "data",
        processCellCallback: (params) => {
          if (typeof params.value === "number") {
            // Return just the number to ensure it stays as a number in Excel
            return params.value;
          }
          return params.value; // For non-numeric values, return as is
        },
      });

      spreadsheets.push(dataSheet);

      // Export combined sheets as an Excel file
      gridRef.current.api.exportMultipleSheetsAsExcel({
        data: spreadsheets,
        fileName: "reports.xlsx",
      });
    };
    performExport();
  }, [gridRef]);

  function findColumnDefByField(columnDefs, field) {
    let result = null;

    // Function to recursively search for the column definition
    function search(columns) {
      for (const column of columns) {
        if (column.field === field) {
          result = column;
          return; // Stop searching once we find the column
        }
        // Recursively search children
        if (column.children) {
          search(column.children);
        }
      }
    }

    search(columnDefs);
    return result;
  }

  const defaultColDef = useMemo(() => {
    return {
      filter: true,
      minWidth: 100,
      flex: 1,
    };
  }, []);
  const detailCellRenderer = useCallback(MasterDetail, []);
  const excelStyles = useMemo(() => {
    return [
      {
        id: "numberFormat",
        numberFormat: {
          format: "#,##0",
        },
      },
      {
        id: "dateType",
        dataType: "DateTime",
      },
      {
        id: "dateUK",
        dataType: "DateTime",
        numberFormat: {
          format: "dd/mm/yy",
        },
      },
      {
        id: "headerName",

        font: {
          bold: true,
        },
      },
      {
        id: "header",
        interior: {
          color: "#f5f6f9", // Gray background
          pattern: "Solid",
        },
        font: {
          bold: true,
          size: 12, // Font size
          color: "#283b5a", // Blue font color
        },
        alignment: {
          horizontal: "Center",
          vertical: "Center",
        },
      },
      {
        id: "hyperlinks",
        font: {
          underline: "Single",
          color: "#358ccb",
        },
      },
      {
        id: "coverSubHeader",
        interior: {
          color: "#2c3e50", // Gray background
          pattern: "Solid",
        },
        font: {
          bold: true,
          size: 16, // Font size
          color: "#ffffff", // Blue font color
        },
        border: {
          top: { style: "thin", color: "#000000" },
          // bottom: { style: 'thin', color: '#000000' },
          // // left: { style: 'thin', color: '#000000' },
          right: { style: "thin", color: "#000000" },
        },
        alignment: {
          horizontal: "Left",
          vertical: "Center",
        },
      },
      {
        id: "coverHeading",
        interior: {
          color: "#2c3e50", // Gray background
          pattern: "Solid",
        },
        font: {
          bold: true,
          size: 22, // Font size
          color: "#ffffff", // Blue font color
        },
        alignment: {
          horizontal: "Center",
          vertical: "Center",
        },
      },
      {
        id: "coverText",
        font: {
          size: 14,
        },
      },
    ];
  }, []);

  const defaultExcelExportParams = useMemo(() => {
    return {
      autoConvertFormulas: true,
      // exportAsExcelTable: true,
      processCellCallback: (params) => {
        const field = params.column.colDef;
        return field.formatType === "INVOICE"
          ? params.value
            ? `=HYPERLINK("${params.value}")`
            : ""
          : params.value;
      },
      rowHeight: (params) => (params.rowIndex === 1 ? 60 : 20),

      addImageToCell: (rowIndex, col, value) => {
        if (rowIndex !== 1) {
          return;
        }
        return {
          image: {
            id: "logo",
            base64: value,
            imageType: "png",
            width: 200,
            height: 200,
            position: {
              colSpan: 4,
            },
          },
        };
      },
    };
  }, []);

  return (
    <div className="AgTable">
      <div className="ag-theme-alpine">
        <div style={{ height: "100%", position: "relative" }}>
          {loadingView ? (
            <div className="CustomLoading">
              <Loader />
            </div>
          ) : (
            <AgGridReact
              popupParent={document.body}
              rowModelType="serverSide"
              columnDefs={columnDefs || []}
              singleClickEdit={props.singleClickEdit}
              onCellEditingStarted={props.onCellEditingStarted}
              onCellValueChanged={props.onCellValueChange}
              // onFirstDataRendered={props.onFirstDataRendered}
              onFirstDataRendered={handleFirstDataRendered}
              pagination={props.pagination}
              editType={"cell"}
              // paginationPageSize={tableRowSize}
              rowSelection="multiple"
              suppressCellSelection={true}
              enableRangeSelection={true}
              enableCharts={true}
              // masterDetail={true}
              // detailCellRenderer={detailCellRenderer}
              // cacheBlockSize={tableRowSize}
              resizable={true}
              enablePivot={true}
              enableSorting={true}
              paginationPageSize={1000}
              cacheBlockSize={1000} // Number of rows per block
              maxBlocksInCache={10}
              // pivotMode={true}
              excelStyles={excelStyles}
              defaultExcelExportParams={defaultExcelExportParams}
              enableFilter={true}
              floatingFilter
              groupMultiAutoColumn={true}
              // columnTypes={{
              //   numericColumn: {
              //     cellClass: "ag-right-aligned-cell",
              //     valueFormatter: (params) => {
              //       const value = params.value;
              //       if (typeof value === "number") {
              //         return value.toLocaleString();
              //       }
              //       return value;
              //     },
              //   },
              // }}
              groupSelectsChildren={props.groupSelectsChildren}
              rowGroupPanelShow="always"
              groupDefaultExpanded={-1}
              sideBar={props.hideToolbar ? {} : sideBar}
              pivotPanelShow="always"
              pivotColumnGroupTotals="before"
              onGridReady={onGridReady}
              // onGridReady={props.onGridReady ? props.onGridReady : onGridReady}
              onModelUpdated={updateFilteredColumn}
              defaultColDef={props.defaultColDef}
              suppressAggFuncInHeader={true}
              ref={gridRef}
              overlayLoadingTemplate={
                '<span class="ag-overlay-loading-center">Loading...</span>'
              }
              overlayNoRowsTemplate={
                '<span class="ag-overlay-loading-center">No Rows to Show</span>'
              }
              // statusBar={statusBar}
              // grandTotalRow={"bottom"}
              // serverSidePivotResultFieldSeparator="_"
              // pinnedTopRowData={[]}
              pinnedBottomRowData={
                grandTotalRow && Object.keys(grandTotalRow).length > 2
                  ? [grandTotalRow]
                  : []
              }
              // pinnedTopRowData={grandTotalRow ? [grandTotalRow] : []}
              processPivotResultColDef={(colDef) => {
                // Apply customizations based on the field or other criteria
                if (colDef.colId.includes("amount")) {
                  colDef.cellRenderer = "customCellRenderer";
                  colDef.cellRendererParams = {
                    customParam: "value",
                  };
                }
                // Customize other pivot columns as needed
                return colDef;
              }}
              onColumnPivotModeChanged={(params) => {
                const columnApi = gridRef.current.columnApi;

                const columnState = columnApi.getColumnState();

                const updatedState = columnState.map((colState) => {
                  const originalColDef = columnDefs.find((def) =>
                    colState.colId.includes(def.field)
                  );

                  if (originalColDef && colState.pivotValueColumn) {
                    return {
                      ...colState,
                      cellRenderer: originalColDef.cellRenderer,
                      cellRendererParams: originalColDef.cellRendererParams,
                    };
                  }

                  return colState;
                });

                // Apply the updated state back to the grid
                columnApi.applyColumnState(updatedState);

                // Optionally refresh the grid if necessary
                params.api.refreshCells({ force: true });
              }}

              autoGroupColumnDef={
                props.autoGroupColumnDef || {
                  headerName: "Group",
                  cellRenderer: "agGroupCellRenderer",

                  // checkboxSelection: (params) =>
                  //   (params.node && params.node.field === "email_hotel_name") ||
                  //   params.node.field === "airline_name",
                  // checkboxSelection: (params) =>
                  //   ((params.node && params.node.field === "email_hotel_name") ||
                  //    params.node.field === "airline_name") ||
                  //   params.node.group === true,
                  checkboxSelection: (params) => {
                    const field = params.colDef?.field;
                  
                    return (
                      field === "email_hotel_name" ||
                      field === "airline_name" ||
                      params.node.group === true
                    );
                  },
                  cellRendererParams: {
                    innerRenderer: (params) => {
                      // Ensure 'params.node.field' is correct for your grouped data
                      const groupField = params.node.field;

                      // Find the original column definition based on the group field
                      const originalColumn = findColumnDefByField(
                        columnDefs,
                        groupField
                      );
                      const groupValue =
                        params.node.key ||
                        params.value ||
                        params.data?.[params.node.field];
                      // Render group header content
                      return (
                        <div
                          style={{
                            display: "flex",
                            width: "100%",
                            alignItems: "center",
                            justifyContent: "center", // Corrected from `justifyItems` to `justifyContent`
                          }}
                        >
                          {handleAgCellDataFormat(
                            originalColumn?.formatType || "",
                            // params.value,
                            groupValue,
                            originalColumn?.formatProps || "",
                            params.data || {}
                          )}
                          {`${
                            grandTotalRow &&
                            Object.keys(grandTotalRow).length > 0 &&
                            params.value === undefined
                              ? `Total (${rowData.length})`
                              : params.value === "NA"
                              ? ""
                              : ""
                          }`}
                          {params?.data[`${params.node.field}_count`] ? (
                            <Typography
                              style={{
                                marginLeft: 4,
                                color: colorPicker("neutral.700"),
                              }}
                              weight={600}
                            >
                              {` (${
                                params?.data[`${params.node.field}_count`]
                              })`}
                            </Typography>
                          ) : null}
                        </div>
                      );
                    },
                  },
                  
                  
                }
              
              }
              onSelectionChanged={(params) => {
                if (props.onSelectionChanged) {
                  props.onSelectionChanged(params.api.getSelectedRows());
                }
              }}
            />
          )}
        </div>
      </div>
      {contextHolder}
    </div>
  );
});

export default AgTableServer;